import React from 'react';

interface JobMismatchModalProps {
  detectedJob: { job_id: number; job_name: string };
  clockedInJob: { job_id: number; job_name: string };
  onSwitch: () => void;
  onIgnore: () => void;
  language: 'en' | 'es';
  switching?: boolean;
  error?: string | null;
}

const translations = {
  en: {
    title: 'Wrong Job',
    youAreAt: 'You are at:',
    clockedInto: 'Clocked into:',
    switchJob: 'SWITCH JOB',
    ignore: 'IGNORE'
  },
  es: {
    title: 'Trabajo Incorrecto',
    youAreAt: 'Estás en:',
    clockedInto: 'Registrado en:',
    switchJob: 'CAMBIAR TRABAJO',
    ignore: 'IGNORAR'
  }
};

export const JobMismatchModal: React.FC<JobMismatchModalProps> = ({
  detectedJob,
  clockedInJob,
  onSwitch,
  onIgnore,
  language,
  switching = false,
  error = null
}) => {
  const t = translations[language];

  return (
    <div className="job-mismatch-backdrop">
      <div className="job-mismatch-modal">
        <div className="job-mismatch-icon">⚠️</div>
        <h2 className="job-mismatch-title">{t.title}</h2>

        <div className="job-mismatch-box detected">
          <span className="job-mismatch-label">{t.youAreAt}</span>
          <span className="job-mismatch-job-name">{detectedJob.job_name}</span>
        </div>

        <div className="job-mismatch-box clocked">
          <span className="job-mismatch-label">{t.clockedInto}</span>
          <span className="job-mismatch-job-name">{clockedInJob.job_name}</span>
        </div>

        {error && (
          <div style={{
            background: '#fee2e2',
            color: '#991b1b',
            padding: '10px 14px',
            borderRadius: '8px',
            fontSize: '14px',
            marginBottom: '8px',
            textAlign: 'center'
          }}>
            {error}
          </div>
        )}

        <button
          className="job-mismatch-btn primary"
          onClick={onSwitch}
          disabled={switching}
          style={{ opacity: switching ? 0.7 : 1 }}
        >
          {switching ? '...' : t.switchJob}
        </button>

        <button
          className="job-mismatch-btn secondary"
          onClick={onIgnore}
          disabled={switching}
        >
          {t.ignore}
        </button>
      </div>
    </div>
  );
};
